
<div style="margin-left: 10px;">
	<div *ngFor="let start of array_start" class="order_start">
		<img src="assets/images/{{start}}" alt="">
	</div>
</div>